import React from "react";
import "./styles/AdList.css";
import "./styles/ProductCard.css";
import "./styles/AdListSkeleton.css";

function AdListSkeletonItem() {
  return (
    <div className="product-card-list__item">
      <div className="product-card ad-skeleton-card">
        <div className="product-card-media ad-skeleton-img" aria-hidden="true" />
        <div className="product-card-body">
          <div className="ad-skeleton-line ad-skeleton-title" aria-hidden="true" />
          <div className="product-card-meta">
            <div className="ad-skeleton-line ad-skeleton-sm" aria-hidden="true" />
            <div className="ad-skeleton-line ad-skeleton-sm" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  );
}

function AdListSkeleton({ count = 8 }) {
  return (
    <div className="product-card-list ad-skeleton-list" aria-busy="true" aria-label="Loading ads">
      {Array.from({ length: count }, (_, index) => (
        <AdListSkeletonItem key={index} />
      ))}
    </div>
  );
}

export default AdListSkeleton;
